export default {
    apiKey: "AIzaSyCxnz15zFkDJLMfvZ2k4YeP-q-gn27vX9s",
    authDomain: "learnengapp.firebaseapp.com",
    databaseURL: "https://learnengapp.firebaseio.com",
    projectId: "learnengapp",
    storageBucket: "",
    messagingSenderId: "657575787585",
    appId: "1:657575787585:web:66d04b42dc3b4a743a1ac0",
    measurementId: "G-X0J6S0NDVK"
}